import { render, staticRenderFns } from "./detailsQuery.vue?vue&type=template&id=6c7b5919"
import script from "./detailsQuery.vue?vue&type=script&lang=js"
export * from "./detailsQuery.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports